module.exports = __webpack_public_path__ + "static/img/yeswecan0020.32ebdd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0020.png
// module id = 595
// module chunks = 1